import {
  Tooltip,
  TooltipVariants,
  type TooltipPlacements
} from "@certa/catalyst/components/Tooltip";
import type { ChannelUserGroup } from "@certa/types";

type MembersViewProps = {
  threadUserGroups: ChannelUserGroup[];
  placement?: TooltipPlacements;
  children: React.ReactElement;
};

const MembersViewTooltip = ({
  threadUserGroups,
  placement,
  children
}: MembersViewProps) => {
  const isExtraMembersCount = threadUserGroups?.length > 1;

  if (!isExtraMembersCount) {
    return children;
  }

  const fullGroupNames = threadUserGroups
    ?.map(group => group.name)
    .slice(1)
    .join(", ");

  return (
    <Tooltip
      placement={placement}
      content={fullGroupNames}
      variant={TooltipVariants.DARK}
      maxWidth="24rem"
    >
      {children}
    </Tooltip>
  );
};

export { MembersViewTooltip };
